import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {UIConfigSessionObject} from '../entities/UIConfigSessionObject';

@Injectable()
export class SessionService {

  constructor() { }

  setSession(bearerToken, userNo, isAdmin): Observable<boolean>
  {
    return new Observable<boolean>( observer => {
      sessionStorage.setItem('userNo',  userNo);
      sessionStorage.setItem('token', bearerToken);
      sessionStorage.setItem('isAdmin', isAdmin);
      observer.next(true);
    });
  }

  setCompanyType(companyType: string){
    sessionStorage.setItem('CompanyType', companyType);
  }

  getCompanyType(): string{
    return sessionStorage.getItem('CompanyType');
  }

  getUserNo(){
    return sessionStorage.getItem('userNo')
  }

  getSessionToken(){
    return sessionStorage.getItem('token');
  }

  logout() {
    sessionStorage.removeItem('userNo');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('isAdmin');
    sessionStorage.removeItem('selectedCompany');
    sessionStorage.removeItem('CompanyType');
    sessionStorage.removeItem('UIConfigSessionObject');
  }

  setUIConfigSession(config : UIConfigSessionObject)
  {
    sessionStorage.setItem('UIConfigSessionObject', JSON.stringify(config));
  }

  getUIConfigSessionObject() : UIConfigSessionObject
  {
    let result = sessionStorage.getItem('UIConfigSessionObject');

    return result != "undefined" ? JSON.parse(result) : new UIConfigSessionObject();
  }


  getSelectedCompany() : string
  {
    return sessionStorage.getItem('selectedCompany');
  }

  setSelectedCompany(company : string)
  {
    sessionStorage.setItem('selectedCompany', company);
  }

  getSalesPersonNo()
  {
    return sessionStorage.getItem('userNo');
  }
}





// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/session.service.ts